import { render, staticRenderFns } from "./SeriousAdverseEvents.vue?vue&type=template&id=647cec12&"
import script from "./SeriousAdverseEvents.vue?vue&type=script&lang=js&"
export * from "./SeriousAdverseEvents.vue?vue&type=script&lang=js&"
import style0 from "./SeriousAdverseEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports